import React, { FC, useMemo } from "react"
import { HashRouter as Router, useLocation } from "react-router-dom"
import { Layout, ConfigProvider } from "antd"
import zhCN from "antd/es/locale/zh_CN"
import Menu from "@component/Menu"
import { renderRoutes, routes } from "./routeConfig"

import "./App.scss"

const { Sider, Content } = Layout

const hideSideMenu = ["/editchart", "/wayzchart", "/ncov", "/industrydb"]

const Side = () => {
  const location = useLocation()
  const path = location.pathname
  const hideSide = useMemo(() => {
    return hideSideMenu.some(menu => path.startsWith(menu))
  }, [path])
  return (
    <Sider className={hideSide ? "hidden" : ""} width={130}>
      <Menu></Menu>
    </Sider>
  )
}

const BIProject: FC = () => {
  return (
    <ConfigProvider locale={zhCN}>
      <Router>
        <div className="p-bi flex flex-column">
          <Layout>
            <Side />
            <Content className="ctx">{renderRoutes(routes)}</Content>
          </Layout>
        </div>
      </Router>
    </ConfigProvider>
  )
}

export default BIProject
